/**
 * Coage um valor numérico num `number` finito, com fallback 0.
 *
 * Usado por utils/lib/pages para normalizar campos de API (montantes,
 * percentagens, contagens) antes de aritmética/formattação. Centralizar evita
 * as ~6 cópias locais que divergiam no tratamento de null/undefined/NaN.
 */
export function toNumber(value) {
  const n = Number(value ?? 0);
  return Number.isFinite(n) ? n : 0;
}
